export default "__VITE_ASSET__COd$XWyr__"